import { EventEmitter } from '@angular/core';

export interface IBoxxForm<T> {
  boxxChange: EventEmitter<T>;
}

export interface IBoxxGenericFormEmitter<DATA> {
  hasChanges: boolean;
  data: DATA;
  valid: boolean;
}
